import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { isAgendamentoLotePath } from "../../../hooks/useAgendamentoStepIndicator/agendamentoV2Steps";
import { useUserPermissions } from "../../../hooks/useUserPermissions";
import { OpcoesServicosEnum } from "../../../enums/opcoesServicos";
import { Tracking } from "../../../services/Tracking";
import { TipoClienteEnum } from "../../../enums/tipoCliente";

const ROTA_POR_SERVICO: Record<OpcoesServicosEnum, string> = {
  [OpcoesServicosEnum.VISTORIA]: "vistoria",
  [OpcoesServicosEnum.EMPLACAMENTO]: "emplacamento",
  [OpcoesServicosEnum.PRIMEIRO_REGISTRO]: "primeiro-registro",
};

const ROTA_POR_SERVICO_LOTE: Partial<Record<OpcoesServicosEnum, string>> = {
  [OpcoesServicosEnum.VISTORIA]: "transferencia",
  [OpcoesServicosEnum.EMPLACAMENTO]: "primeiro-emplacamento",
};

export const useServicesV2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { uuidAgendamento } = useParams();
  const stepIndicator = useAgendamentoStepIndicator();
  const { isUserType } = useUserPermissions();
  const [servicoSelecionado, setServicoSelecionado] =
    useState<OpcoesServicosEnum | null>(null);

  const isDespachante = isUserType(TipoClienteEnum.DESPACHANTE);
  const isLoteAgendamento =
    isAgendamentoLotePath(location.pathname) && isDespachante;

  function handleSelect(opcao: OpcoesServicosEnum) {
    setServicoSelecionado(opcao);
    Tracking.userAction("mapa:agendamento/servicos:clique-selecionar-servico");
  }

  function handleAvancar() {
    if (!servicoSelecionado) return;

    Tracking.userAction("mapa:agendamento/servicos:clique-botao-avancar");

    const rotaBase = isLoteAgendamento
      ? `/agendamento-lote/${uuidAgendamento}/servicos`
      : `/agendamento/${uuidAgendamento}/servicos`;
    const rotaServico = isLoteAgendamento
      ? ROTA_POR_SERVICO_LOTE[servicoSelecionado]
      : ROTA_POR_SERVICO[servicoSelecionado];

    navigate(`${rotaBase}/${rotaServico}`);
  }

  return {
    stepIndicator,
    servicoSelecionado,
    isLoteAgendamento,
    handleSelect,
    handleAvancar,
  };
};
